import { Button, Icon, Text } from '@shared/widgets';
import FilledTrashIcon from '@assets/icons/filled-trash.svg';
import { AccountType } from '@shared/api/rest/accounts';

interface PropsType {
  id: number;
  type: AccountType;
  onClose: () => void;
  onDelete: (id: number) => void;
}

export const ModalDeleteConfirmation = (props: PropsType) => {
  const deleteCaption = props.type === AccountType.Card ? 'Card' : 'Account';

  return (
    <div className='fixed inset-0 z-[9999] flex items-center justify-center bg-black bg-opacity-50'>
      <div className='bg-white dark:bg-eerie-black py-14 px-24 shadow-lg w-full max-w-[556px]'>
        <Icon icon={<FilledTrashIcon />} className='flex justify-center mb-6' color='primary' />
        <div className='text-center'>
          <Text className='mb-2' weight='semibold' size='2xl'>
            Delete {deleteCaption}
          </Text>
          <Text className='mb-6'>You are about to delete the {deleteCaption}. Are you sure?</Text>
          <div className='flex gap-3 justify-center'>
            <Button color='outlined' fullWidth onClick={props.onClose}>
              Cancel
            </Button>
            <Button color='primary' fullWidth onClick={() => props.onDelete(props.id)}>
              Delete {deleteCaption}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
